import { render, staticRenderFns } from "./ChoiceCard.vue?vue&type=template&id=363afa6a&scoped=true&"
import script from "./ChoiceCard.vue?vue&type=script&lang=js&"
export * from "./ChoiceCard.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceCard.vue?vue&type=style&index=0&id=363afa6a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363afa6a",
  null
  
)

export default component.exports